/* ==========================================================================
   ZONA VET SHOP · CARRITO
   ========================================================================== */

(() => {
  'use strict';

  const CART_SELECTOR = '[data-zv-cart]';

  function initCart(cartRoot) {
    if (!cartRoot || cartRoot.dataset.zvCartInitialized === 'true') return;
    cartRoot.dataset.zvCartInitialized = 'true';

    const form = cartRoot.querySelector('[data-zv-cart-form]');
    if (!form) return;

    let isUpdating = false;

    const setBusy = (busy) => {
      isUpdating = busy;
      cartRoot.classList.toggle('is-updating', busy);

      cartRoot
        .querySelectorAll(
          '[data-zv-quantity-minus], [data-zv-quantity-plus], [data-zv-quantity-input]'
        )
        .forEach((control) => {
          control.disabled = busy;
        });
    };

    const updateLine = async (line, quantity) => {
      if (isUpdating) return;

      const normalizedQuantity = Math.max(
        0,
        Number.parseInt(quantity, 10) || 0
      );

      setBusy(true);

      try {
        const root = window.Shopify?.routes?.root || '/';

        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            line,
            quantity: normalizedQuantity
          })
        });

        if (!response.ok) {
          throw new Error(`Cart update failed: ${response.status}`);
        }

        window.location.reload();
      } catch (error) {
        console.error(
          '[Zona Vet Shop] No se pudo actualizar el carrito.',
          error
        );

        const fallback = cartRoot.querySelector('[data-zv-cart-update]');

        if (fallback) {
          fallback.click();
        } else {
          form.submit();
        }
      }
    };

    cartRoot.addEventListener('click', (event) => {
      const minusButton = event.target.closest('[data-zv-quantity-minus]');
      const plusButton = event.target.closest('[data-zv-quantity-plus]');

      if (!minusButton && !plusButton) return;

      event.preventDefault();

      const wrapper = event.target.closest('[data-zv-quantity]');
      const input = wrapper?.querySelector('[data-zv-quantity-input]');

      if (!input) return;

      const line = Number.parseInt(input.dataset.line, 10);
      const current = Number.parseInt(input.value, 10) || 0;

      if (!line) return;

      updateLine(line, minusButton ? Math.max(0, current - 1) : current + 1);
    });

    cartRoot.addEventListener('change', (event) => {
      const input = event.target.closest('[data-zv-quantity-input]');
      if (!input) return;

      const line = Number.parseInt(input.dataset.line, 10);
      const quantity = Number.parseInt(input.value, 10);

      if (!line || Number.isNaN(quantity)) return;

      updateLine(line, quantity);
    });
  }

  function initAll() {
    document.querySelectorAll(CART_SELECTOR).forEach(initCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
